import { useEffect } from "react";
import Lenis from "lenis";
import "@/App.css";
import Navbar from "@/components/curry/Navbar";
import Hero from "@/components/curry/Hero";
import InfoBar from "@/components/curry/InfoBar";
import About from "@/components/curry/About";
import Dishes from "@/components/curry/Dishes";
import Marquee from "@/components/curry/Marquee";
import MenuShowcase from "@/components/curry/MenuShowcase";
import Testimonials from "@/components/curry/Testimonials";
import Location from "@/components/curry/Location";
import Footer from "@/components/curry/Footer";
import FloatingBar from "@/components/curry/FloatingBar";

export default function App() {
  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.09, smoothWheel: true });
    let raf;
    const loop = (time) => {
      lenis.raf(time);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);

    const onClick = (e) => {
      const anchor = e.target.closest('a[href^="#"]');
      if (!anchor) return;
      const id = anchor.getAttribute("href");
      const el = id.length > 1 && document.querySelector(id);
      if (el) {
        e.preventDefault();
        lenis.scrollTo(el, { offset: -64, duration: 1.4 });
      }
    };
    document.addEventListener("click", onClick);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
      document.removeEventListener("click", onClick);
    };
  }, []);

  return (
    <div className="App bg-[#FDFCF9] text-[#2A211A] antialiased">
      <Navbar />
      <main>
        <Hero />
        <InfoBar />
        <About />
        <Dishes />
        <Marquee />
        <MenuShowcase />
        <Testimonials />
        <Location />
      </main>
      <Footer />
      <FloatingBar />
    </div>
  );
}
